import angular from 'angular';
import oversightDataService from '../data/oversight.data.service';
import ISharedModelService from './ISharedModel.service';


let _$filter;
let _oversightDataService;

export class oversightSharedModelService extends ISharedModelService {
  constructor(
    $filter,
    oversightDataService, // eslint-disable-line no-shadow
  ) {
    super('am');
    _$filter = $filter;
    _oversightDataService = oversightDataService;

    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.agendas = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.agendaItemStatuses = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.coordinators = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.applicationUsers = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.AgendaTypes = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.ScheduleTypes = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    // this.auditTypes = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    // this.findingStatuses = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    // this.preparationItemStatuses = null;

    console.log('app.services.oversightSharedModelService created');
  }

  /** ********************************************************************************************
   *  ********************************************************************************************
   *  ********************************************************************************************
   * CRUD Operations
   *
   */

  /** ******************************************
   * Agenda CATEGORIES
   */

  getAgendaCategories(agendaId) { // , forceRefresh = false) {
    // if (forceRefresh || !this.cache.am.findingCategories[auditId]) {
    // this.cache.am.findingCategories[auditId] = _amDataService.getFindingCategoriesByAudit(auditId)
    return _oversightDataService.getAgendaCategoriesByAgenda(agendaId)
      .then(response => response.data.result);
    // }
    // return this.cache.am.findingCategories[auditId];
  }

  getAgendaCategoryItems(categoryId) { // , forceRefresh = false) {
    return _oversightDataService.getAgendaCategoryItems(categoryId, true)
      .then(response => response.data.result);
  }

  getAgendaCategorySubItems(itemId) { // , forceRefresh = false) {
    return _oversightDataService.getAgendaCategorySubItems(itemId)
      .then(response => response.data.result);
  }


  /**
   *
   * @param collection - array of object with canView property
   * @param {Object} propertyObject - Object containing the property to search and the desired value
   * @returns {Array<Object>}
   */
  filterByProperty(collection, propertyObject) {
    return _$filter('filter')(collection, propertyObject);
  }
}

oversightSharedModelService.$inject = [
  '$filter',
  'oversightDataService',
];

export default angular.module('app.services.oversightSharedModelService', [
  oversightDataService,
])
  .service('oversightSharedModelService', oversightSharedModelService)
  .name;
